export enum Country {
  UnitedKingdom = 'United Kingdom',
  Afghanistan = 'Afghanistan',
  AlandIslands = 'Aland Islands',
  Albania = 'Albania',
  Algeria = 'Algeria',
  AmericanSamoa = 'American Samoa',
  Andorra = 'Andorra',
  Angola = 'Angola',
  Anguilla = 'Anguilla',
  Antarctica = 'Antarctica',
  AntiguaAndBarbuda = 'Antigua and Barbuda',
  Argentina = 'Argentina',
  Armenia = 'Armenia',
  Aruba = 'Aruba',
  Australia = 'Australia',
  Austria = 'Austria',
  Azerbaijan = 'Azerbaijan',
  Bahamas = 'Bahamas, The',
  Bahrain = 'Bahrain',
  Bangladesh = 'Bangladesh',
  Barbados = 'Barbados',
  Belarus = 'Belarus',
  Belgium = 'Belgium',
  Belize = 'Belize',
  Benin = 'Benin',
  Bermuda = 'Bermuda',
  Bhutan = 'Bhutan',
  Bolivia = 'Bolivia',
  BonaireSintEustatiusAndSaba = 'Bonaire, Sint Eustatius and Saba',
  BosniaAndHerzegovina = 'Bosnia and Herzegovina',
  Botswana = 'Botswana',
  Brazil = 'Brazil',
  BritishIndianOceanTerritory = 'British Indian Ocean Territory',
  BritishVirginIslands = 'British Virgin Islands',
  Brunei = 'Brunei',
  Bulgaria = 'Bulgaria',
  BurkinaFaso = 'Burkina Faso',
  Burundi = 'Burundi',
  Cambodia = 'Cambodia',
  Cameroon = 'Cameroon',
  Canada = 'Canada',
  CapeVerde = 'Cape Verde',
  CaymanIslands = 'Cayman Islands',
  CentralAfricanRepublic = 'Central African Republic',
  Chad = 'Chad',
  Chile = 'Chile',
  China = 'China',
  ChristmasIsland = 'Christmas Island',
  CocosIslands = 'Cocos Islands',
  Colombia = 'Colombia',
  Comoros = 'Comoros',
  CongoDemocraticRepublic = 'Congo, Democratic Republic of',
  CongoRepublic = 'Congo, Republic of the',
  CookIslands = 'Cook Islands',
  CostaRica = 'Costa Rica',
  CoteDIvoire = "Cote d'Ivoire",
  Croatia = 'Croatia',
  Cuba = 'Cuba',
  Curacao = 'Curacao',
  Cyprus = 'Cyprus',
  CzechRepublic = 'Czech Republic',
  Denmark = 'Denmark',
  Djibouti = 'Djibouti',
  Dominica = 'Dominica',
  DominicanRepublic = 'Dominican Republic',
  Ecuador = 'Ecuador',
  Egypt = 'Egypt',
  ElSalvador = 'El Salvador',
  EquatorialGuinea = 'Equatorial Guinea',
  Eritrea = 'Eritrea',
  Estonia = 'Estonia',
  Eswatini = 'Eswatini',
  Ethiopia = 'Ethiopia',
  FalklandIslands = 'Falkland Islands',
  FaroeIslands = 'Faroe Islands',
  Fiji = 'Fiji',
  Finland = 'Finland',
  France = 'France',
  FrenchGuiana = 'French Guiana',
  FrenchPolynesia = 'French Polynesia',
  Gabon = 'Gabon',
  Gambia = 'Gambia, The',
  Georgia = 'Georgia',
  Germany = 'Germany',
  Ghana = 'Ghana',
  Gibraltar = 'Gibraltar',
  Greece = 'Greece',
  Greenland = 'Greenland',
  Grenada = 'Grenada',
  Guadeloupe = 'Guadeloupe',
  Guam = 'Guam',
  Guatemala = 'Guatemala',
  Guernsey = 'Guernsey',
  Guinea = 'Guinea',
  GuineaBissau = 'Guinea-Bissau',
  Guyana = 'Guyana',
  Haiti = 'Haiti',
  Honduras = 'Honduras',
  HongKong = 'Hong Kong',
  Hungary = 'Hungary',
  Iceland = 'Iceland',
  India = 'India',
  Indonesia = 'Indonesia',
  Iran = 'Iran',
  Iraq = 'Iraq',
  Ireland = 'Ireland',
  IsleOfMan = 'Isle of Man',
  Israel = 'Israel',
  Italy = 'Italy',
  Jamaica = 'Jamaica',
  Japan = 'Japan',
  Jersey = 'Jersey',
  Jordan = 'Jordan',
  Kazakhstan = 'Kazakhstan',
  Kenya = 'Kenya',
  Kiribati = 'Kiribati',
  KoreaNorth = 'Korea, North',
  KoreaSouth = 'Korea, South',
  Kosovo = 'Kosovo',
  Kuwait = 'Kuwait',
  Kyrgyzstan = 'Kyrgyzstan',
  Laos = 'Laos',
  Latvia = 'Latvia',
  Lebanon = 'Lebanon',
  Lesotho = 'Lesotho',
  Liberia = 'Liberia',
  Libya = 'Libya',
  Liechtenstein = 'Liechtenstein',
  Lithuania = 'Lithuania',
  Luxembourg = 'Luxembourg',
  Macau = 'Macau',
  Madagascar = 'Madagascar',
  Malawi = 'Malawi',
  Malaysia = 'Malaysia',
  Maldives = 'Maldives',
  Mali = 'Mali',
  Malta = 'Malta',
  MarshallIslands = 'Marshall Islands',
  Martinique = 'Martinique',
  Mauritania = 'Mauritania',
  Mauritius = 'Mauritius',
  Mayotte = 'Mayotte',
  Mexico = 'Mexico',
  Micronesia = 'Micronesia, Federated States of',
  Moldova = 'Moldova',
  Monaco = 'Monaco',
  Mongolia = 'Mongolia',
  Montenegro = 'Montenegro',
  Montserrat = 'Montserrat',
  Morocco = 'Morocco',
  Mozambique = 'Mozambique',
  Myanmar = 'Myanmar',
  Namibia = 'Namibia',
  Nauru = 'Nauru',
  Nepal = 'Nepal',
  Netherlands = 'Netherlands',
  NewCaledonia = 'New Caledonia',
  NewZealand = 'New Zealand',
  Nicaragua = 'Nicaragua',
  Niger = 'Niger',
  Nigeria = 'Nigeria',
  Niue = 'Niue',
  NorfolkIsland = 'Norfolk Island',
  NorthMacedonia = 'North Macedonia',
  NorthernMarianaIslands = 'Northern Mariana Islands',
  Norway = 'Norway',
  Oman = 'Oman',
  Pakistan = 'Pakistan',
  Palau = 'Palau',
  Panama = 'Panama',
  PapuaNewGuinea = 'Papua New Guinea',
  Paraguay = 'Paraguay',
  Peru = 'Peru',
  Philippines = 'Philippines',
  Pitcairn = 'Pitcairn',
  Poland = 'Poland',
  Portugal = 'Portugal',
  PuertoRico = 'Puerto Rico',
  Qatar = 'Qatar',
  Reunion = 'Reunion',
  Romania = 'Romania',
  Russia = 'Russia',
  Rwanda = 'Rwanda',
  SaintBarthelemy = 'Saint Barthélemy',
  SaintHelenaAscensionAndTristanDaCunha = 'Saint Helena, Ascension and Tristan da Cunha',
  SaintKittsAndNevis = 'Saint Kitts and Nevis',
  SaintLucia = 'Saint Lucia',
  SaintMartin = 'Saint Martin',
  SaintPierreAndMiquelon = 'Saint Pierre and Miquelon',
  SaintVincentAndGrenadines = 'Saint Vincent and the Grenadines',
  Samoa = 'Samoa',
  SanMarino = 'San Marino',
  SaoTomeAndPrincipe = 'Sao Tome and Principe',
  SaudiArabia = 'Saudi Arabia',
  Senegal = 'Senegal',
  Serbia = 'Serbia',
  Seychelles = 'Seychelles',
  SierraLeone = 'Sierra Leone',
  Singapore = 'Singapore',
  SintMaarten = 'Sint Maarten',
  Slovakia = 'Slovakia',
  Slovenia = 'Slovenia',
  SolomonIslands = 'Solomon Islands',
  Somalia = 'Somalia',
  SouthAfrica = 'South Africa',
  SouthSudan = 'South Sudan',
  Spain = 'Spain',
  SriLanka = 'Sri Lanka',
  Sudan = 'Sudan',
  Suriname = 'Suriname',
  SvalbardAndJanMayen = 'Svalbard and Jan Mayen',
  Swaziland = 'Swaziland',
  Sweden = 'Sweden',
  Switzerland = 'Switzerland',
  Syria = 'Syria',
  Taiwan = 'Taiwan',
  Tajikistan = 'Tajikistan',
  Tanzania = 'Tanzania',
  Thailand = 'Thailand',
  TimorLeste = 'Timor-Leste',
  Togo = 'Togo',
  Tokelau = 'Tokelau',
  Tonga = 'Tonga',
  TrinidadAndTobago = 'Trinidad and Tobago',
  Tunisia = 'Tunisia',
  Turkey = 'Turkey',
  Turkmenistan = 'Turkmenistan',
  TurksAndCaicosIslands = 'Turks and Caicos Islands',
  Tuvalu = 'Tuvalu',
  Uganda = 'Uganda',
  Ukraine = 'Ukraine',
  UnitedArabEmirates = 'United Arab Emirates',
  UnitedStates = 'United States',
  UnitedStatesMinorOutlyingIslands = 'United States Minor Outlying Islands',
  Uruguay = 'Uruguay',
  Uzbekistan = 'Uzbekistan',
  Vanuatu = 'Vanuatu',
  Vatican = 'Vatican',
  Venezuela = 'Venezuela',
  Vietnam = 'Vietnam',
  VirginIslands = 'Virgin Islands',
  WallisAndFutuna = 'Wallis and Futuna',
  WestBank = 'West Bank',
  WesternSahara = 'Western Sahara',
  Yemen = 'Yemen',
  Zambia = 'Zambia',
  Zimbabwe = 'Zimbabwe',
}

export const nationality = Object.values(Country).map((country) => ({
  Country: country,
}));

// create a country list with the country names and country ids, and sort it by country name. The ids are created from the country names by removing all non-alphanumeric characters and converting to lower case.
export const countryDropdownList = Object.values(Country).map((country) => ({
  value: country,
  label: country,
}));

export const countries = [
  { name: Country.Afghanistan, code: 'AF', dialingCode: '+93' },
  { name: Country.AlandIslands, code: 'AX', dialingCode: '+358' },
  { name: Country.Albania, code: 'AL', dialingCode: '+355' },
  { name: Country.Algeria, code: 'DZ', dialingCode: '+213' },
  { name: Country.AmericanSamoa, code: 'AS', dialingCode: '+1-684' },
  { name: Country.Andorra, code: 'AD', dialingCode: '+376' },
  { name: Country.Angola, code: 'AO', dialingCode: '+244' },
  { name: Country.Anguilla, code: 'AI', dialingCode: '+1-264' },
  { name: Country.Antarctica, code: 'AQ', dialingCode: '+672' },
  { name: Country.AntiguaAndBarbuda, code: 'AG', dialingCode: '+1-268' },
  { name: Country.Argentina, code: 'AR', dialingCode: '+54' },
  { name: Country.Armenia, code: 'AM', dialingCode: '+374' },
  { name: Country.Aruba, code: 'AW', dialingCode: '+297' },
  { name: Country.Australia, code: 'AU', dialingCode: '+61' },
  { name: Country.Austria, code: 'AT', dialingCode: '+43' },
  { name: Country.Azerbaijan, code: 'AZ', dialingCode: '+994' },
  { name: Country.Bahamas, code: 'BS', dialingCode: '+1-242' },
  { name: Country.Bahrain, code: 'BH', dialingCode: '+973' },
  { name: Country.Bangladesh, code: 'BD', dialingCode: '+880' },
  { name: Country.Barbados, code: 'BB', dialingCode: '+1-246' },
  { name: Country.Belarus, code: 'BY', dialingCode: '+375' },
  { name: Country.Belgium, code: 'BE', dialingCode: '+32' },
  { name: Country.Belize, code: 'BZ', dialingCode: '+501' },
  { name: Country.Benin, code: 'BJ', dialingCode: '+229' },
  { name: Country.Bermuda, code: 'BM', dialingCode: '+1-441' },
  { name: Country.Bhutan, code: 'BT', dialingCode: '+975' },
  { name: Country.Bolivia, code: 'BO', dialingCode: '+591' },
  { name: Country.BonaireSintEustatiusAndSaba, code: 'BQ', dialingCode: '+599' },
  { name: Country.BosniaAndHerzegovina, code: 'BA', dialingCode: '+387' },
  { name: Country.Botswana, code: 'BW', dialingCode: '+267' },
  { name: Country.Brazil, code: 'BR', dialingCode: '+55' },
  { name: Country.BritishIndianOceanTerritory, code: 'IO', dialingCode: '+246' },
  { name: Country.BritishVirginIslands, code: 'VG', dialingCode: '+1-284' },
  { name: Country.Brunei, code: 'BN', dialingCode: '+673' },
  { name: Country.Bulgaria, code: 'BG', dialingCode: '+359' },
  { name: Country.BurkinaFaso, code: 'BF', dialingCode: '+226' },
  { name: Country.Burundi, code: 'BI', dialingCode: '+257' },
  { name: Country.Cambodia, code: 'KH', dialingCode: '+855' },
  { name: Country.Cameroon, code: 'CM', dialingCode: '+237' },
  { name: Country.Canada, code: 'CA', dialingCode: '+1' },
  { name: Country.CapeVerde, code: 'CV', dialingCode: '+238' },
  { name: Country.CaymanIslands, code: 'KY', dialingCode: '+1-345' },
  { name: Country.CentralAfricanRepublic, code: 'CF', dialingCode: '+236' },
  { name: Country.Chad, code: 'TD', dialingCode: '+235' },
  { name: Country.Chile, code: 'CL', dialingCode: '+56' },
  { name: Country.China, code: 'CN', dialingCode: '+86' },
  { name: Country.ChristmasIsland, code: 'CX', dialingCode: '+61' },
  { name: Country.CocosIslands, code: 'CC', dialingCode: '+61' },
  { name: Country.Colombia, code: 'CO', dialingCode: '+57' },
  { name: Country.Comoros, code: 'KM', dialingCode: '+269' },
  { name: Country.CongoDemocraticRepublic, code: 'CD', dialingCode: '+243' },
  { name: Country.CongoRepublic, code: 'CG', dialingCode: '+242' },
  { name: Country.CookIslands, code: 'CK', dialingCode: '+682' },
  { name: Country.CostaRica, code: 'CR', dialingCode: '+506' },
  { name: Country.CoteDIvoire, code: 'CI', dialingCode: '+225' },
  { name: Country.Croatia, code: 'HR', dialingCode: '+385' },
  { name: Country.Cuba, code: 'CU', dialingCode: '+53' },
  { name: Country.Curacao, code: 'CW', dialingCode: '+599' },
  { name: Country.Cyprus, code: 'CY', dialingCode: '+357' },
  { name: Country.CzechRepublic, code: 'CZ', dialingCode: '+420' },
  { name: Country.Denmark, code: 'DK', dialingCode: '+45' },
  { name: Country.Djibouti, code: 'DJ', dialingCode: '+253' },
  { name: Country.Dominica, code: 'DM', dialingCode: '+1-767' },
  { name: Country.DominicanRepublic, code: 'DO', dialingCode: '+1-809' },
  { name: Country.Ecuador, code: 'EC', dialingCode: '+593' },
  { name: Country.Egypt, code: 'EG', dialingCode: '+20' },
  { name: Country.ElSalvador, code: 'SV', dialingCode: '+503' },
  { name: Country.EquatorialGuinea, code: 'GQ', dialingCode: '+240' },
  { name: Country.Eritrea, code: 'ER', dialingCode: '+291' },
  { name: Country.Estonia, code: 'EE', dialingCode: '+372' },
  { name: Country.Eswatini, code: 'SZ', dialingCode: '+268' },
  { name: Country.Ethiopia, code: 'ET', dialingCode: '+251' },
  { name: Country.FalklandIslands, code: 'FK', dialingCode: '+500' },
  { name: Country.FaroeIslands, code: 'FO', dialingCode: '+298' },
  { name: Country.Fiji, code: 'FJ', dialingCode: '+679' },
  { name: Country.Finland, code: 'FI', dialingCode: '+358' },
  { name: Country.France, code: 'FR', dialingCode: '+33' },
  { name: Country.FrenchGuiana, code: 'GF', dialingCode: '+594' },
  { name: Country.FrenchPolynesia, code: 'PF', dialingCode: '+689' },
  { name: Country.Gabon, code: 'GA', dialingCode: '+241' },
  { name: Country.Gambia, code: 'GM', dialingCode: '+220' },
  { name: Country.Georgia, code: 'GE', dialingCode: '+995' },
  { name: Country.Germany, code: 'DE', dialingCode: '+49' },
  { name: Country.Ghana, code: 'GH', dialingCode: '+233' },
  { name: Country.Gibraltar, code: 'GI', dialingCode: '+350' },
  { name: Country.Greece, code: 'GR', dialingCode: '+30' },
  { name: Country.Greenland, code: 'GL', dialingCode: '+299' },
  { name: Country.Grenada, code: 'GD', dialingCode: '+1-473' },
  { name: Country.Guadeloupe, code: 'GP', dialingCode: '+590' },
  { name: Country.Guam, code: 'GU', dialingCode: '+1-671' },
  { name: Country.Guatemala, code: 'GT', dialingCode: '+502' },
  { name: Country.Guernsey, code: 'GG', dialingCode: '+44' },
  { name: Country.Guinea, code: 'GN', dialingCode: '+224' },
  { name: Country.GuineaBissau, code: 'GW', dialingCode: '+245' },
  { name: Country.Guyana, code: 'GY', dialingCode: '+592' },
  { name: Country.Haiti, code: 'HT', dialingCode: '+509' },
  { name: Country.Honduras, code: 'HN', dialingCode: '+504' },
  { name: Country.HongKong, code: 'HK', dialingCode: '+852' },
  { name: Country.Hungary, code: 'HU', dialingCode: '+36' },
  { name: Country.Iceland, code: 'IS', dialingCode: '+354' },
  { name: Country.India, code: 'IN', dialingCode: '+91' },
  { name: Country.Indonesia, code: 'ID', dialingCode: '+62' },
  { name: Country.Iran, code: 'IR', dialingCode: '+98' },
  { name: Country.Iraq, code: 'IQ', dialingCode: '+964' },
  { name: Country.Ireland, code: 'IE', dialingCode: '+353' },
  { name: Country.IsleOfMan, code: 'IM', dialingCode: '+44' },
  { name: Country.Israel, code: 'IL', dialingCode: '+972' },
  { name: Country.Italy, code: 'IT', dialingCode: '+39' },
  { name: Country.Jamaica, code: 'JM', dialingCode: '+1-876' },
  { name: Country.Japan, code: 'JP', dialingCode: '+81' },
  { name: Country.Jersey, code: 'JE', dialingCode: '+44' },
  { name: Country.Jordan, code: 'JO', dialingCode: '+962' },
  { name: Country.Kazakhstan, code: 'KZ', dialingCode: '+7' },
  { name: Country.Kenya, code: 'KE', dialingCode: '+254' },
  { name: Country.Kiribati, code: 'KI', dialingCode: '+686' },
  { name: Country.KoreaNorth, code: 'KP', dialingCode: '+850' },
  { name: Country.KoreaSouth, code: 'KR', dialingCode: '+82' },
  { name: Country.Kosovo, code: 'XK', dialingCode: '+383' },
  { name: Country.Kuwait, code: 'KW', dialingCode: '+965' },
  { name: Country.Kyrgyzstan, code: 'KG', dialingCode: '+996' },
  { name: Country.Laos, code: 'LA', dialingCode: '+856' },
  { name: Country.Latvia, code: 'LV', dialingCode: '+371' },
  { name: Country.Lebanon, code: 'LB', dialingCode: '+961' },
  { name: Country.Lesotho, code: 'LS', dialingCode: '+266' },
  { name: Country.Liberia, code: 'LR', dialingCode: '+231' },
  { name: Country.Libya, code: 'LY', dialingCode: '+218' },
  { name: Country.Liechtenstein, code: 'LI', dialingCode: '+423' },
  { name: Country.Lithuania, code: 'LT', dialingCode: '+370' },
  { name: Country.Luxembourg, code: 'LU', dialingCode: '+352' },
  { name: Country.Macau, code: 'MO', dialingCode: '+853' },
  { name: Country.Madagascar, code: 'MG', dialingCode: '+261' },
  { name: Country.Malawi, code: 'MW', dialingCode: '+265' },
  { name: Country.Malaysia, code: 'MY', dialingCode: '+60' },
  { name: Country.Maldives, code: 'MV', dialingCode: '+960' },
  { name: Country.Mali, code: 'ML', dialingCode: '+223' },
  { name: Country.Malta, code: 'MT', dialingCode: '+356' },
  { name: Country.MarshallIslands, code: 'MH', dialingCode: '+692' },
  { name: Country.Martinique, code: 'MQ', dialingCode: '+596' },
  { name: Country.Mauritania, code: 'MR', dialingCode: '+222' },
  { name: Country.Mauritius, code: 'MU', dialingCode: '+230' },
  { name: Country.Mayotte, code: 'YT', dialingCode: '+262' },
  { name: Country.Mexico, code: 'MX', dialingCode: '+52' },
  { name: Country.Micronesia, code: 'FM', dialingCode: '+691' },
  { name: Country.Moldova, code: 'MD', dialingCode: '+373' },
  { name: Country.Monaco, code: 'MC', dialingCode: '+377' },
  { name: Country.Mongolia, code: 'MN', dialingCode: '+976' },
  { name: Country.Montenegro, code: 'ME', dialingCode: '+382' },
  { name: Country.Montserrat, code: 'MS', dialingCode: '+1-664' },
  { name: Country.Morocco, code: 'MA', dialingCode: '+212' },
  { name: Country.Mozambique, code: 'MZ', dialingCode: '+258' },
  { name: Country.Myanmar, code: 'MM', dialingCode: '+95' },
  { name: Country.Namibia, code: 'NA', dialingCode: '+264' },
  { name: Country.Nauru, code: 'NR', dialingCode: '+674' },
  { name: Country.Nepal, code: 'NP', dialingCode: '+977' },
  { name: Country.Netherlands, code: 'NL', dialingCode: '+31' },
  { name: Country.NewCaledonia, code: 'NC', dialingCode: '+687' },
  { name: Country.NewZealand, code: 'NZ', dialingCode: '+64' },
  { name: Country.Nicaragua, code: 'NI', dialingCode: '+505' },
  { name: Country.Niger, code: 'NE', dialingCode: '+227' },
  { name: Country.Nigeria, code: 'NG', dialingCode: '+234' },
  { name: Country.Niue, code: 'NU', dialingCode: '+683' },
  { name: Country.NorfolkIsland, code: 'NF', dialingCode: '+672' },
  { name: Country.NorthMacedonia, code: 'MK', dialingCode: '+389' },
  { name: Country.NorthernMarianaIslands, code: 'MP', dialingCode: '+1-670' },
  { name: Country.Norway, code: 'NO', dialingCode: '+47' },
  { name: Country.Oman, code: 'OM', dialingCode: '+968' },
  { name: Country.Pakistan, code: 'PK', dialingCode: '+92' },
  { name: Country.Palau, code: 'PW', dialingCode: '+680' },
  { name: Country.Panama, code: 'PA', dialingCode: '+507' },
  { name: Country.PapuaNewGuinea, code: 'PG', dialingCode: '+675' },
  { name: Country.Paraguay, code: 'PY', dialingCode: '+595' },
  { name: Country.Peru, code: 'PE', dialingCode: '+51' },
  { name: Country.Philippines, code: 'PH', dialingCode: '+63' },
  { name: Country.Pitcairn, code: 'PN', dialingCode: '+872' },
  { name: Country.Poland, code: 'PL', dialingCode: '+48' },
  { name: Country.Portugal, code: 'PT', dialingCode: '+351' },
  { name: Country.PuertoRico, code: 'PR', dialingCode: '+1-787' },
  { name: Country.Qatar, code: 'QA', dialingCode: '+974' },
  { name: Country.Reunion, code: 'RE', dialingCode: '+262' },
  { name: Country.Romania, code: 'RO', dialingCode: '+40' },
  { name: Country.Russia, code: 'RU', dialingCode: '+7' },
  { name: Country.Rwanda, code: 'RW', dialingCode: '+250' },
  { name: Country.SaintBarthelemy, code: 'BL', dialingCode: '+590' },
  { name: Country.SaintHelenaAscensionAndTristanDaCunha, code: 'SH', dialingCode: '+290' },
  { name: Country.SaintKittsAndNevis, code: 'KN', dialingCode: '+1-869' },
  { name: Country.SaintLucia, code: 'LC', dialingCode: '+1-758' },
  { name: Country.SaintMartin, code: 'MF', dialingCode: '+590' },
  { name: Country.SaintPierreAndMiquelon, code: 'PM', dialingCode: '+508' },
  { name: Country.SaintVincentAndGrenadines, code: 'VC', dialingCode: '+1-784' },
  { name: Country.Samoa, code: 'WS', dialingCode: '+685' },
  { name: Country.SanMarino, code: 'SM', dialingCode: '+378' },
  { name: Country.SaoTomeAndPrincipe, code: 'ST', dialingCode: '+239' },
  { name: Country.SaudiArabia, code: 'SA', dialingCode: '+966' },
  { name: Country.Senegal, code: 'SN', dialingCode: '+221' },
  { name: Country.Serbia, code: 'RS', dialingCode: '+381' },
  { name: Country.Seychelles, code: 'SC', dialingCode: '+248' },
  { name: Country.SierraLeone, code: 'SL', dialingCode: '+232' },
  { name: Country.Singapore, code: 'SG', dialingCode: '+65' },
  { name: Country.SintMaarten, code: 'SX', dialingCode: '+1-721' },
  { name: Country.Slovakia, code: 'SK', dialingCode: '+421' },
  { name: Country.Slovenia, code: 'SI', dialingCode: '+386' },
  { name: Country.SolomonIslands, code: 'SB', dialingCode: '+677' },
  { name: Country.Somalia, code: 'SO', dialingCode: '+252' },
  { name: Country.SouthAfrica, code: 'ZA', dialingCode: '+27' },
  { name: Country.SouthSudan, code: 'SS', dialingCode: '+211' },
  { name: Country.Spain, code: 'ES', dialingCode: '+34' },
  { name: Country.SriLanka, code: 'LK', dialingCode: '+94' },
  { name: Country.Sudan, code: 'SD', dialingCode: '+249' },
  { name: Country.Suriname, code: 'SR', dialingCode: '+597' },
  { name: Country.SvalbardAndJanMayen, code: 'SJ', dialingCode: '+47' },
  { name: Country.Swaziland, code: 'SZ', dialingCode: '+268' },
  { name: Country.Sweden, code: 'SE', dialingCode: '+46' },
  { name: Country.Switzerland, code: 'CH', dialingCode: '+41' },
  { name: Country.Syria, code: 'SY', dialingCode: '+963' },
  { name: Country.Taiwan, code: 'TW', dialingCode: '+886' },
  { name: Country.Tajikistan, code: 'TJ', dialingCode: '+992' },
  { name: Country.Tanzania, code: 'TZ', dialingCode: '+255' },
  { name: Country.Thailand, code: 'TH', dialingCode: '+66' },
  { name: Country.TimorLeste, code: 'TL', dialingCode: '+670' },
  { name: Country.Togo, code: 'TG', dialingCode: '+228' },
  { name: Country.Tokelau, code: 'TK', dialingCode: '+690' },
  { name: Country.Tonga, code: 'TO', dialingCode: '+676' },
  { name: Country.TrinidadAndTobago, code: 'TT', dialingCode: '+1-868' },
  { name: Country.Tunisia, code: 'TN', dialingCode: '+216' },
  { name: Country.Turkey, code: 'TR', dialingCode: '+90' },
  { name: Country.Turkmenistan, code: 'TM', dialingCode: '+993' },
  { name: Country.TurksAndCaicosIslands, code: 'TC', dialingCode: '+1-649' },
  { name: Country.Tuvalu, code: 'TV', dialingCode: '+688' },
  { name: Country.Uganda, code: 'UG', dialingCode: '+256' },
  { name: Country.Ukraine, code: 'UA', dialingCode: '+380' },
  { name: Country.UnitedArabEmirates, code: 'AE', dialingCode: '+971' },
  { name: Country.UnitedKingdom, code: 'GB', dialingCode: '+44' },
  { name: Country.UnitedStates, code: 'US', dialingCode: '+1' },
  { name: Country.UnitedStatesMinorOutlyingIslands, code: 'UM', dialingCode: '+1' },
  { name: Country.Uruguay, code: 'UY', dialingCode: '+598' },
  { name: Country.Uzbekistan, code: 'UZ', dialingCode: '+998' },
  { name: Country.Vanuatu, code: 'VU', dialingCode: '+678' },
  { name: Country.Vatican, code: 'VA', dialingCode: '+379' },
  { name: Country.Venezuela, code: 'VE', dialingCode: '+58' },
  { name: Country.Vietnam, code: 'VN', dialingCode: '+84' },
  { name: Country.VirginIslands, code: 'VI', dialingCode: '+1-340' },
  { name: Country.WallisAndFutuna, code: 'WF', dialingCode: '+681' },
  { name: Country.WestBank, code: 'PS', dialingCode: '+970' },
  { name: Country.WesternSahara, code: 'EH', dialingCode: '+212' },
  { name: Country.Yemen, code: 'YE', dialingCode: '+967' },
  { name: Country.Zambia, code: 'ZM', dialingCode: '+260' },
  { name: Country.Zimbabwe, code: 'ZW', dialingCode: '+263' },
];

export const countryDialingCodeDropdownList = countries.reduce<
  Array<{ label: string; value: string }>
>((acc, country) => {
  if (!acc.some(item => item.value === country.dialingCode)) {
    acc.push({
      label: country.dialingCode,
      value: country.dialingCode,
    });
  }
  return acc;
}, []);

export const EuCountries = [
  Country.Austria,
  Country.Belgium,
  Country.Bulgaria,
  Country.Croatia,
  Country.Cyprus,
  Country.CzechRepublic,
  Country.Denmark,
  Country.Estonia,
  Country.Finland,
  Country.France,
  Country.Germany,
  Country.Greece,
  Country.Hungary,
  Country.Ireland,
  Country.Italy,
  Country.Latvia,
  Country.Lithuania,
  Country.Luxembourg,
  Country.Malta,
  Country.Netherlands,
  Country.Poland,
  Country.Portugal,
  Country.Romania,
  Country.Slovakia,
  Country.Slovenia,
  Country.Spain,
  Country.Sweden,
  Country.Iceland,
  Country.Norway,
  Country.Liechtenstein,
];
